import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { DEFAULT_ASPECT_RATIO } from "../constants";
import { isValidAspectRatio } from "../helpers/commonUtils";
import { usePlayerStore } from "../store/usePlayerStore";

export const resolveAspectRatio = (
  aspectRatio: string | undefined,
  streamAspectRatio: string | undefined
) => {
  const ratio =
    (aspectRatio === "auto" ? streamAspectRatio : aspectRatio) ||
    DEFAULT_ASPECT_RATIO.LANDSCAPE;

  if (!isValidAspectRatio(ratio)) {
    console.warn("Invalid aspect ratio", ratio);
    return DEFAULT_ASPECT_RATIO.LANDSCAPE;
  }

  return ratio;
};

const AspectRatioWrapper = styled.div<{ paddingTop?: string }>`
  display: block;
  width: 100%;
  ${({ paddingTop }) => (paddingTop ? `padding-top: ${paddingTop};` : "")}
`;

export const PreviewAspectRatio = ({
  children,
  ...attrs
}: {
  children?: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>) => {
  const { useStoreState } = usePlayerStore();
  const aspectRatio = useStoreState.aspectRatio();
  // We render children after the paddingTop is set, because otherwise child elements "drop" when paddingTop has been added
  const [paddingTop, setPaddingTop] = useState<string>();

  useEffect(() => {
    const [aspectRatioWidth, aspectRatioHeight] = (
      aspectRatio || DEFAULT_ASPECT_RATIO.LANDSCAPE
    ).split(":");
    setPaddingTop((+aspectRatioHeight / +aspectRatioWidth) * 100 + "%"); // padding-top percentage is based on parent element width
  }, [aspectRatio]);

  return (
    <AspectRatioWrapper paddingTop={paddingTop} {...attrs}>
      {paddingTop && children}
    </AspectRatioWrapper>
  );
};
